<div fxLayout="column" fxLayoutAlign="center" >
  <app-subscriptions-report></app-subscriptions-report>
</div>